import { DeliveryOptionsTranslation } from "@swo/storefront";

import { ReactComponent as FreeShippingIcon } from "../../../assets/icons/pdp-free-shipping.svg";
import { ReactComponent as ShippingTimeIcon } from "../../../assets/icons/pdp-shipping-time.svg";
import { ReactComponent as ReturnPolicyIcon } from "../../../assets/icons/pdp-return-policy.svg";
import { Translated } from "../../../domain/translations/translations";
import type { PDPInformationSetData } from "./information-set/PDPInformationSet";

export function getInformationSetDeliveryData(t: Translated<DeliveryOptionsTranslation>): PDPInformationSetData {
  return [
    { IconComponent: FreeShippingIcon, label: t("freeShipping") },
    { IconComponent: ShippingTimeIcon, label: t("deliveryDuration") },
    { IconComponent: ReturnPolicyIcon, label: t("returnGuarantee") },
  ];
}
